const CONSTANTS = {
  DEFAULT_LOCALE: 'en-US',
  DEFAULT_COUNTRY: 'US',
  DEFAULT_AMOUNT: '2000',
  URL: 'https://checkoutshopper-test.adyen.com/checkoutshopper/v1/sessions/',
  currencies: {
    AR: 'ARS',
    AU: 'AUD',
    BR: 'BRL',
    CA: 'CAD',
    CH: 'CHF',
    CN: 'CNY',
    CZ: 'CZK',
    DK: 'DKK',
    GB: 'GBP',
    HK: 'HKD',
    HR: 'HRK',
    HU: 'HUN',
    ID: 'IDR',
    IN: 'INR',
    JP: 'JPY',
    KR: 'KRW',
    MG: 'MGA',
    MX: 'MXN',
    MY: 'MYR',
    NO: 'NOK',
    NZ: 'NZD',
    PH: 'PHP',
    PL: 'PLN',
    RO: 'RON',
    RU: 'RUB',
    SE: 'SEK',
    SG: 'SGD',
    TH: 'THB',
    TW: 'TWD',
    US: 'USD',
    VN: 'VND',
    LA: 'LAK',
    RS: 'RSD',
    default: 'EUR',
  },
  DUMMY_ADDRESS_VALUES_FOR_AFTER_PAY: {
    address1: 'DUMMY ADDRESS 1',
    address2: 'DUMMY ADDRESS 2',
    firstName: 'DUMMY_FIRSTNAME',
    lastName: 'DUMMY_LASTNAME',
    phone: '11111111111',
    email: 'dummy@mail.com',
    city: 'DUMMY CITY',
    postalCode: '11111',
    stateCode: 'XX',
  },
};
export default CONSTANTS;
